/**
 * Local Imports
*/

import { IndexPermission } from './IndexPermission';

/**
 * Exports
*/

export {
  IndexPermission
}